<template>
  <div class="tx-products module-products-list -max-width-limited">
    <div class="products__list">
      <div class="products__filter">
        <FilterBar></FilterBar>
      </div>
      <div class="products__list--list">
        <ResultList></ResultList>
      </div>
    </div>
  </div>
</template>

<script >
import ResultList from './components/ResultList.vue'
import FilterBar from './components/FilterBar.vue'
import { useGlobalStore } from '@/stores'

export default {
  components: {
    ResultList,
    FilterBar
  },
  setup () {
    const globals = useGlobalStore()
    globals.init()
  }
}
</script>
